import {
  Activity, Heart, Wind, Brain, AlertCircle, FlaskConical,
  Folder, Baby, Smile, ClipboardList, Pill,
  Zap, AlertTriangle, Info, Lightbulb
} from "lucide-react";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const LOCAL_APP_VERSION = "1.3.1";

export const iconMap = {
  activity: Activity,
  heart: Heart,
  wind: Wind,
  brain: Brain,
  "alert-circle": AlertCircle,
  "flask-conical": FlaskConical,
  folder: Folder,
  baby: Baby,
  smile: Smile,
  "clipboard-list": ClipboardList,
  pill: Pill,
};

export const careLevels = {
  sfa: { label: "Standard First Aid", shortLabel: "SFA", color: "sky" },
  emr: { label: "Emergency Medical Responder", shortLabel: "EMR", color: "emerald" },
  pcp: { label: "Primary Care Paramedic", shortLabel: "PCP", color: "blue" },
  pcp_es: { label: "Primary Care Paramedic – ES", shortLabel: "PCP-ES", color: "purple" },
  acp_g: { label: "Advanced Care Paramedic – Ground", shortLabel: "ACP-G", color: "yellow" },
  wes: { label: "Paramedic Specialist", shortLabel: "PCP-PS", color: "orange" },
  acp_f: { label: "Advanced Care Paramedic – Flight", shortLabel: "ACP-F", color: "green" },
  ccp: { label: "Critical Care Paramedic", shortLabel: "CCP", color: "red" },
};

// Care level hierarchy per service
export const CARE_LEVEL_ORDER = ['pcp', 'pcp_es', 'acp_g'];
export const SFA_EMR_CARE_LEVEL_ORDER = ['sfa', 'emr'];
export const WES_CARE_LEVEL_ORDER = ['wes'];
export const AIR_CARE_LEVEL_ORDER = ['acp_f', 'ccp'];

// Map service to its care level order
export const SERVICE_CARE_LEVELS = {
  ground: CARE_LEVEL_ORDER,
  sfa_emr: SFA_EMR_CARE_LEVEL_ORDER,
  wes: WES_CARE_LEVEL_ORDER,
  air_adult: AIR_CARE_LEVEL_ORDER,
  air_pediatric: AIR_CARE_LEVEL_ORDER,
};

export const infoBoxConfig = {
  critical: { 
    icon: Zap, 
    className: "border-red-500/50 bg-red-500/10 text-slate-900 dark:text-red-100",
    iconClass: "text-red-600 dark:text-red-500"
  },
  warning: { 
    icon: AlertTriangle, 
    className: "border-amber-500/50 bg-amber-500/10 text-slate-900 dark:text-amber-100",
    iconClass: "text-amber-600 dark:text-amber-500"
  },
  info: { 
    icon: Info, 
    className: "border-blue-500/50 bg-blue-500/10 text-slate-900 dark:text-blue-100",
    iconClass: "text-blue-600 dark:text-blue-500"
  },
  tip: { 
    icon: Lightbulb, 
    className: "border-green-500/50 bg-green-500/10 text-slate-900 dark:text-green-100",
    iconClass: "text-green-600 dark:text-green-500"
  },
};
